import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { Resources } from '../components/Resources';
import { FAQ } from '../components/FAQ';
export function ResourcesPage() {
  return <main className="bg-white" data-id="element-554">
      <PageBanner title="Resources & Forms" subtitle="Download forms, find authorization numbers, and access helpful resources for your fingerprinting needs" data-id="element-555" />
      <Resources data-id="element-556" />
      <FAQ data-id="element-557" />
    </main>;
}